import React, { Component } from 'react';
import firebase from 'firebase';
import 'moment/locale/es';
import './style.css';
import Select from 'react-select';
import carImg from '../../img/car.png';
import RutaItem from './RutaItem';
import copyright from '../../img/copyright-gray.png';
import { Pulse } from 'react-preloading-component';

class Rutas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tiposViajes: [],
            filtro: { label: 'Todos', value: 'Todos' },
            rutas: [],
            isLoading: true,
            numRegistros: 5,
            maxRegistros: 0,
        }
    }

    componentDidMount() {
        this.getTiposViaje();
        this.getRutas();
        firebase.database().ref('Rutas').orderByChild('estado').once('value').then(snap => {
            this.setState({ maxRegistros: snap.numChildren() });
        });
    }

    async getTiposViaje() {
        firebase.database().ref('TiposViajes').on('value', snap => {
            let tiposViajes = [];
            let o = { label: 'Todas las rutas', value: 'Todos' };
            tiposViajes.push(o);
            snap.forEach(element => {
                let obje = element.val();
                o = { label: obje.nombre, value: element.key };
                tiposViajes.push(o);
            });
            this.setState({ tiposViajes });
        })
    }

    selectTipoViaje(filtro) {
        this.setState({ filtro });
    }

    async getRutas() {
        let { numRegistros } = this.state;
        firebase.database().ref('Rutas').orderByChild('estado').limitToFirst(numRegistros).once('value').then(snap => {
            let rutas = [];
            snap.forEach((element, i) => {
                let obje = element.val();
                rutas.push({ ...obje, key: element.key });
            });
            this.setState({ rutas: rutas, isLoading: false });
        })
    }

    filterRutas() {
        return this.state.filtro.value === 'Todos' ? this.state.rutas : this.state.rutas.filter(ruta => '' + ruta.tipoViaje === this.state.filtro.value);
    }

    async loadMoreRutas() {
        this.setState({ numRegistros: Number(this.state.numRegistros) + 5, isLoading: true });
        await this.getTiposViaje();
        await this.getRutas();
        await this.filterRutas();
    }

    renderBoton() {
        let { maxRegistros, numRegistros } = this.state;
        if (numRegistros < maxRegistros) {
            return (
                <button type="button" onClick={() => this.loadMoreRutas()} className="btn btn-success btn-sm">Cargar mas rutas</button>
            )
        }
    }

    render() {
        let { tiposViajes, filtro, isLoading } = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row header-margin-top">
                        <div className="col-md-1">
                            <img src={carImg} className="img-fluid m-top-img" />
                        </div>
                        <div className="col-md-11">
                            <h3 className="title-blue">Rutas</h3>
                            <span className="text-info">Visualización de unidades en ruta</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active show" id="unidades-tab" data-toggle="tab" href="#unidades" role="tab"
                                        aria-controls="unidades" aria-selected="true"><i className="fa fa-bars"></i>&nbsp;&nbsp;&nbsp;Listado de rutas</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade active show" id="unidades" role="tabpanel" aria-labelledby="unidades-tab">
                            <div className="row">
                                <div className="col-12 col-md-3">
                                    <form>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-3 col-form-label">Filtros</label>
                                            <div className="col-sm-12 col-md-9">
                                                <Select placeholder='Seleccione...' value={filtro} className="css-10nd86i-2" onChange={(e) => this.selectTipoViaje(e)} options={tiposViajes} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-12 col-md-6"></div>
                                <div className="col-12 col-md-3 text-right"><button type="button" onClick={() => this.props.history.push('/newRutes')} className="btn btn-success btn-sm">Crear nueva ruta</button></div>
                            </div>
                            <div className="row justify-content-md-center">
                                <div className="col-10" style={{ marginTop: '2%', marginBottom: '5%' }}>
                                    {
                                        isLoading == true && <Pulse />
                                    }
                                    {
                                        this.filterRutas().map(ruta => {
                                            return (
                                                <div key={ruta.key} className="col-12" key={ruta.key} style={{ marginTop: '2%' }}>
                                                    <RutaItem ruta={ruta} tiposViajes={tiposViajes} />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div>
                                <center>
                                    {this.renderBoton()}
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer-pg mt-auto py-3" style={{ width: '100%' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 col-sm-4">
                            </div>
                            <div className="col-sm">
                                <img src={copyright} />
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        )

    }
}

export default Rutas;



// WEBPACK FOOTER //
// ./src/Components/Rutas/Rutas.js